"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuditRecords = void 0;
const axios_1 = __importDefault(require("axios"));
async function getAuditRecords(objectId, objectType, params = {}) {
    console.log('getAuditRecords:objectId, objectType, params', objectId, objectType, params);
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `/https-audit/api/audit/${objectType}/${objectId}`,
        params
    });
    return resp.data;
}
exports.getAuditRecords = getAuditRecords;
